import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { TTicketComment } from '../types/ticket-comment.type';

export const CreateTicketCommentValidationSchema = z.object({
  ticketId: z.string({ message: 'Ticket ID is required' }).min(1),
  content: z
    .string({ message: 'Comment cannot be empty' })
    .trim()
    .min(1, 'Comment cannot be empty')
    .max(30000, 'Comment cannot be more than 30000 characters'),
  hasMention: z.boolean(),
});
export type TCreateTicketCommentValidation = z.infer<typeof CreateTicketCommentValidationSchema>;
export type TCreateTicketCommentPayload = TCreateTicketCommentValidation;
export type TCreateTicketCommentResponse = ApiResponse<TTicketComment>;

export const createTicketComment = (payload: TCreateTicketCommentPayload): Promise<TCreateTicketCommentResponse> => {
  const url = `/comment`;

  return axiosInstance.post(url, payload);
};

/**
 * Use Create Ticket Comment React-Query Hook
 */
type UseCreateTicketCommentMutationOptions = {
  mutationConfig?: TypedMutationConfig<typeof createTicketComment, AxiosErrorCustom>;
};

export const useCreateTicketCommentMutation = ({ mutationConfig }: UseCreateTicketCommentMutationOptions) => {
  const { ...restConfig } = mutationConfig ?? {};

  return useMutation({
    mutationFn: createTicketComment,
    ...restConfig,
  });
};
